export default __webpack_public_path__ + "static/media/MCWA_Dashboard_HeroImage.e71c4529.jpg";